import _extends from '../../node_modules/@babel/runtime-corejs3/helpers/esm/extends.js';
import React, { useState, useMemo } from 'react';
import { isDefined } from '@togglecorp/fujs';
import { fromLonLat } from '../../node_modules/ol/proj.js';
import TextNode from '../TextNode/index.js';
import TileLayer from './Layers/TileLayer.js';
import MapboxLayer from './Layers/MapboxLayer.js';
import HeatmapLayer from './Layers/HeatmapLayer.js';
import SymbolLayer from './Layers/SymbolLayer.js';
import LineLayer from './Layers/LineLayer.js';
import OlMap from './OlMap/index.js';
import MapContext from './MapContext.js';

function getLayerId(type, id) {
  return `${type}-${id}`;
}
// const defaultCenter = [30.21, 15.86] as const;

function Map(props) {
  const {
    title,
    subTitle,
    center,
    layers,
    ...olMapProps
  } = props;
  const [map, setMap] = useState(null);
  const renderLayers = useMemo(() => {
    const renderLayersArr = layers.map(layer => {
      if (layer.type === 'heatmap' && layer.visible) {
        return /*#__PURE__*/React.createElement(HeatmapLayer, _extends({
          key: getLayerId(layer.type, layer.id)
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, layer.options));
      }
      if (layer.type === 'mapbox' && layer.visible) {
        return /*#__PURE__*/React.createElement(MapboxLayer, _extends({
          key: getLayerId(layer.type, layer.id)
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, layer.options));
      }
      if (layer.type === 'osm' && layer.visible) {
        return /*#__PURE__*/React.createElement(TileLayer, _extends({
          key: getLayerId(layer.type, layer.id)
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, layer.options));
      }
      if (layer.type === 'symbol' && layer.visible) {
        return /*#__PURE__*/React.createElement(SymbolLayer, _extends({
          key: getLayerId(layer.type, layer.id)
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, layer.options));
      }
      if (layer.type === 'line' && layer.visible) {
        return /*#__PURE__*/React.createElement(LineLayer, _extends({
          key: getLayerId(layer.type, layer.id)
          // eslint-disable-next-line react/jsx-props-no-spreading
        }, layer.options));
      }
      /*
          if ((layer.type === 'mask') && (layer.visible > 0)) {
              return (
                  <MaskLayer
                      map={map}
                      key={`maskLayer${layer.id}`}
                      id={layer.id}
                      source={mask()}
                      polygon={layer.mask}
                      zIndex={layer.zIndex}
                      opacity={layer.opacity}
                      blur={layer.blur}
                      smoothing={layer.smoothing}
                  />
              );
          }
      */

      return undefined;
    });
    return renderLayersArr;
  }, [layers]);
  const mapContextValue = useMemo(() => ({
    map,
    setMap
  }), [map, setMap]);
  return /*#__PURE__*/React.createElement(MapContext.Provider, {
    value: mapContextValue
  }, isDefined(title) && /*#__PURE__*/React.createElement(TextNode, _extends({
    as: "h2"
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, title)), isDefined(subTitle) && /*#__PURE__*/React.createElement(TextNode
  // eslint-disable-next-line react/jsx-props-no-spreading
  , subTitle), /*#__PURE__*/React.createElement(OlMap
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _extends({}, olMapProps, {
    center: fromLonLat(center)
  }), renderLayers));
}

export { Map as default };
//# sourceMappingURL=index.js.map
